import { Grid, Tooltip} from "@mui/material";

export function getMfproductStruct(){
    return {
        id:{
            name:'id',
            label:'ID',
            value:'',
            error:false,
            errorMessage:'',
            required:false
        },
        
        businessid:{
            name:'businessid',
            label:'Business Id',
            value:'',
            error:false,
            errorMessage:'You must enter Business Id',
            required:true,
            fieldtype:'ID'
        },
        title:{
            name:'title',
            label:'Title',
            value:'',
            error:false,
            errorMessage:'You must enter Title',
            required:true,
            fieldtype:'string'
        },
        imageurl:{
            name:'imageurl',
            label:'imageurl',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        description:{
            name:'description',
            label:'Description',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        code:{
            name:'code',
            label:'Code',
            value:'',
            error:false,
            errorMessage:'You must enter Code',
            required:true,
            fieldtype:'string'
        },
        stockcount:{
            name:'stockcount',
            label:'Stock Count',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'number'
        },
        categoryid:{
            name:'categoryid',
            label:'Category Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'bodynamiclist'
        },
        categoryname:{
            name:'categoryname',
            label:'Category Name',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        stockincoming:{
            name:'stockincoming',
            label:'Stock Incoming',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'number'
        },
        price:{
            name:'price',
            label:'Price',
            value:'',
            error:false,
            errorMessage:'You must enter Price',
            required:true,
            fieldtype:'double'
        },
      }
}

export function getColumns(payload){
  let actionList = [
        
        { field: 'title', headerName: 'Title', width:250 },
        { field: 'description', headerName: 'Description', width:150 },
        { field: 'code', headerName: 'Code', width:150 },
        { field: 'stockcount', headerName: 'Stock Count', width:150 },
        { field: 'categoryid', headerName: 'Category Id', width:150 },
        { field: 'categoryname', headerName: 'Category Name', width:150 },
        { field: 'stockincoming', headerName: 'Stock Incoming', width:150 },
        { field: 'price', headerName: 'Price', width:150 },
  ];
  if (payload!==undefined){
    payload.actionList && payload.actionList.map((actionObj)=>{
    actionList.push(
      {
        field: actionObj.title,
        headerName: actionObj.title,
        sortable: false,
        width:60,
        disableClickEventBubbling: false,
        renderCell: (params) => {
          return (
              <Grid item onClick={()=>{actionObj.callBackMethod(params.row.id)}}>
                <Tooltip title={actionObj.title} sx={{cursor: "pointer"}}>
                  {actionObj.icon}
                </Tooltip>
              </Grid>
          );
        }
      })
    })
  }
  return actionList;
}

export function setData(data, formValues, setFormValues){
   
    setFormValues({
      ['id']:{
        ...formValues['id'],
        value:data.id,
      },
       ['businessid']:{
          ...formValues['businessid'],
          value:data.businessid,
        },['title']:{
          ...formValues['title'],
          value:data.title,
        },['imageurl']:{
          ...formValues['imageurl'],
          value:data.imageurl,
        },['description']:{
          ...formValues['description'],
          value:data.description,
        },['code']:{
          ...formValues['code'],
          value:data.code,
        },['stockcount']:{
          ...formValues['stockcount'],
          value:data.stockcount,
        },['categoryid']:{
          ...formValues['categoryid'],
          value:data.categoryid,
        },['categoryname']:{
          ...formValues['categoryname'],
          value:data.categoryname,
        },['stockincoming']:{
          ...formValues['stockincoming'],
          value:data.stockincoming,
        },['price']:{
          ...formValues['price'],
          value:data.price,
        },
      })
}